var module = angular.module('octopusApp.library');

module.controller('FeedEditController', function($scope, $stateParams, $state, $location, busy, pageTitle, octopusRepository, octoDialog, unsavedChanges) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    var feedId = $stateParams["id"];
    $scope.feed = null;
    $scope.feeds = {
        "NuGet": "NuGet Feed",
        "Docker": "Docker Container Registry"
    };
    $scope.updateOptions = updateOptions;
    $scope.save = save;
    $scope.defaultDownloadAttempts = 5;
    $scope.defaultDownloadRetryBackoffSeconds = 10;
    $scope.defaultEnhancedMode = false;

    function updateOptions() {
        if ($scope.feed.FeedType === "NuGet") {
            if (!$scope.feed.DownloadAttempts) {
                $scope.feed.DownloadAttempts = $scope.defaultDownloadAttempts;
            }
            if (!$scope.feed.DownloadRetryBackoffSeconds) {
                $scope.feed.DownloadRetryBackoffSeconds = $scope.defaultDownloadRetryBackoffSeconds;
            }
            if (!$scope.feed.EnhancedMode) {
                $scope.feed.EnhancedMode = $scope.defaultEnhancedMode;
            }
        } else {
            delete $scope.feed.DownloadAttempts;
            delete $scope.feed.DownloadRetryBackoffSeconds;
            delete $scope.feed.EnhancedMode;
        }
    }

    function init() {
        if (feedId) {
            isLoading.promise(octopusRepository.Feeds.get(feedId).then(function (feed) {
                $scope.feed = feed;
                pageTitle(feed.Name);
                $scope.showAdvanced =
                    ($scope.feed.DownloadAttempts !== $scope.defaultDownloadAttempts) ||
                    ($scope.feed.DownloadRetryBackoffSeconds !== $scope.defaultDownloadRetryBackoffSeconds) ||
                    ($scope.feed.EnhancedMode !== $scope.defaultEnhancedMode);
            }));
        } else {
            $scope.feed = {
                Password: {},
                FeedType: "NuGet"};
            pageTitle('Create feed');
        }
    }

    function save(redirectToTestPage) {
        // Set defaults if they are missing
        if ($scope.feed.FeedType === "NuGet") {
            if ($scope.feed.DownloadAttempts === null) {
                $scope.feed.DownloadAttempts = $scope.defaultDownloadAttempts;
            }
            if ($scope.feed.DownloadRetryBackoffSeconds === null) {
                $scope.feed.DownloadRetryBackoffSeconds = $scope.defaultDownloadRetryBackoffSeconds;
            }
            if ($scope.feed.EnhancedMode === null) {
                $scope.feed.EnhancedMode = $scope.defaultEnhancedMode;
            }
        }
        isSaving.promise(octopusRepository.Feeds.save($scope.feed).then(function (saved) {
            unsavedChanges.saved();
            if (redirectToTestPage) {
                $location.path('/library/feeds/' + saved.Id + '/test');
            } else {
                $state.go('app.library.feeds');
            }
        }));
    }

    init();
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/feeds/controllers/feed_edit_controller.js
// module id = 3528854074107368
// module chunks = 1